import React, { useRef } from "react";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { WhyBicenter } from "@/components/WhyBicenter";
import { LOBSolutions } from "@/components/LOBSolutions";
import { LOBActivate } from "@/components/LOBActivate";
import { EcosystemExtras } from "@/components/EcosystemExtras";
import { DemoBooking } from "@/components/DemoBooking";
import { Events } from "@/components/Events";
import { AccessLevels } from "@/components/AccessLevels";
import { Roadmap } from "@/components/Roadmap";
import { JoinUs } from "@/components/JoinUs";
import { ContactSection } from "@/components/ContactSection";
import { Footer } from "@/components/Footer";
import { SEO } from "@/components/SEO";
import { CookieBanner } from "@/components/CookieBanner";
import { CopyProtection } from "@/components/CopyProtection";
import { Toaster } from "@/components/ui/sonner";

const Home = () => {
  const demoRef = useRef(null);

  const handleBookDemo = (solutionKey) => {
    if (demoRef.current?.selectSolution) {
      demoRef.current.selectSolution(solutionKey);
    } else {
      const el = document.getElementById("demo");
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white antialiased" data-testid="home-page">
      <SEO />
      <Header />
      <main>
        <Hero />
        <WhyBicenter />
        <LOBSolutions onBookDemo={handleBookDemo} />
        <LOBActivate />
        <EcosystemExtras />
        <DemoBooking ref={demoRef} />
        <Events />
        <AccessLevels />
        <Roadmap />
        <JoinUs />
        <ContactSection />
      </main>
      <Footer />
      <CookieBanner />
      <CopyProtection />
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
};

export default Home;
